import { render, staticRenderFns } from "./headlinesChange.vue?vue&type=template&id=22fed3fb&scoped=true"
import script from "./headlinesChange.vue?vue&type=script&lang=js"
export * from "./headlinesChange.vue?vue&type=script&lang=js"
import style0 from "./headlinesChange.vue?vue&type=style&index=0&id=22fed3fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fed3fb",
  null
  
)

export default component.exports